import axios from '../plugins/axios';

export default {
  loadAlarmList(parameter) {
    const url = process.env.VUE_APP_OFFICE_ALARM_URL + `/notifications`;

    return axios.get(url, parameter);
  },

  /**
   * readAlarm
   * @param {string} targetId - 수정하려는 타겟 id
   * @param {object} parameter - 전체 알림 체크 할 경우에만 추가
   * @param {object} parameter.range - targetId 위로로 전체 읽음 처리 : gte
   * @param {object} parameter.type - office , mail 이나 office 만 사용함
   */
  readAlarm(targetId, parameter) {
    const url = process.env.VUE_APP_OFFICE_ALARM_URL + `/notifications/${targetId}`;

    return axios.patch(url, parameter);
  },
};
